import { useContext, useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import INTOUCH_API from "../../services/Api";
import useCurrentUserData from "../../hooks/useCurrentUserData";
import { useTranslation } from "react-i18next";
import useCurrentGame from "../../hooks/useCurrentGame";
import { SOCKET_EVENTS, SocketContext } from "../../components/SocketProvider";
const questionnaire = [
  {
    title: "insight_questionnaire_form_page.question1",
    number: 1,
    type: "text",
    value: "",
    userAnswer: "",
    partnerAnswer: "",
  },
  {
    title: "insight_questionnaire_form_page.question2",
    number: 2,
    type: "rating",
    value: "",
    userAnswer: "",
    partnerAnswer: "",
  },
  {
    title: "insight_questionnaire_form_page.question3",
    number: 3,
    type: "text",
    value: "",
    userAnswer: "",
    partnerAnswer: "",
  },
  {
    title: "insight_questionnaire_form_page.question4",
    number: 4,
    type: "rating",
    value: "",
    userAnswer: "",
    partnerAnswer: "",
  },
  {
    title: "insight_questionnaire_form_page.question5",
    number: 5,
    type: "text",
    value: "",
    userAnswer: "",
    partnerAnswer: "",
  },
  {
    title: "insight_questionnaire_form_page.question6",
    number: 6,
    type: "text",
    value: "",
    userAnswer: "",
    partnerAnswer: "",
  },
  {
    title: "insight_questionnaire_form_page.question7",
    number: 7,
    type: "text",
    value: "",
    userAnswer: "",
    partnerAnswer: "",
  },
  {
    title: "insight_questionnaire_form_page.question8",
    number: 8,
    type: "dropdown",
    value: "",
    userAnswer: "",
    partnerAnswer: "",
  },
  {
    title: "insight_questionnaire_form_page.question9",
    number: 9,
    type: "text",
    value: "",
    userAnswer: "",
    partnerAnswer: "",
  },
  {
    title: "insight_questionnaire_form_page.question10",
    number: 10,
    type: "text",
    value: "",
    userAnswer: "",
    partnerAnswer: "",
  },
  {
    title: "insight_questionnaire_form_page.question11",
    number: 11,
    type: "text",
    value: "",
    userAnswer: "",
    partnerAnswer: "",
  },
  {
    title: "insight_questionnaire_form_page.question12",
    number: 12,
    type: "text",
    value: "",
    userAnswer: "",
    partnerAnswer: "",
  },
  {
    title: "insight_questionnaire_form_page.question13",
    number: 13,
    type: "text",
    value: "",
    userAnswer: "",
    partnerAnswer: "",
  },
  {
    title: "insight_questionnaire_form_page.question14",
    number: 14,
    type: "text",
    value: "",
    userAnswer: "",
    partnerAnswer: "",
  },
  {
    title: "insight_questionnaire_form_page.question15",
    number: 15,
    type: "text",
    value: "",
    userAnswer: "",
    partnerAnswer: "",
  },
];

export default function useViewController() {
  const [questions, setQuestions] = useState(() => questionnaire);
  const [questionInfo, setQuestionInfo] = useState(null);
  const [questionsLoading, setQuestionsLoading] = useState(true);
  const { sendEvent } = useContext(SocketContext);
  const { getUserData } = useCurrentUserData();
  const { getCurrentGame } = useCurrentGame();
  const location = useLocation();
  const { i18n } = useTranslation();

  const questionName = useMemo(() => {
    // индивидуальная (пустая) анкета: заголовок = введённое название (карточки нет)
    if (questionInfo?.formType === "BLANK") {
      return questionInfo?.customTitle || "";
    }
    if (!questionInfo?.question) return "";
    const user = getUserData();
    const genderSign = user.gender.slice(0, 1);
    const language = i18n.language;

    return questionInfo.question[`${genderSign}_${language}`];
  }, [i18n.language, questionInfo]);

  useEffect(() => {
    INTOUCH_API.requestManager(
      "getInsightFormAnswer",
      { formId: location.state.formId },
      (response) => {
        setQuestionInfo(response.data);
      },
      () => {}
    );
  }, [location.state.formId, questionInfo?.question?.id]);

  const setQuestionsWithAnswers = (data, partnerId) => {
    const user = getUserData();
    const pairQuestions = questionnaire.map((question) => {
      const userQuestionAnswerInfo = data.find(
        (question) => question.userId === user.id
      );
      const partnerQuestionAnswerInfo = data.find(
        (question) => partnerId === question.userId
      );
      const userAnswer = userQuestionAnswerInfo.insightFormAnswers.find(
        (answer) => answer.numberQuestion === question.number
      );
      const partnerAnswer = partnerQuestionAnswerInfo.insightFormAnswers.find(
        (answer) => answer.numberQuestion === question.number
      );
      return {
        ...question,
        userAnswer,
        partnerAnswer,
      };
    });
    setQuestions(pairQuestions);
  };

  useEffect(() => {
    // BLANK-анкета: карточки нет — пара ответов грузится по pairKey
    if (questionInfo?.formType === "BLANK" && questionInfo?.pairKey) {
      const game = getCurrentGame();
      INTOUCH_API.requestManager(
        "getInsightFormPairByPairKey",
        { payload: { pairKey: questionInfo.pairKey, gameId: game.id } },
        (response) => {
          setQuestionsWithAnswers(response.data, game.partner.id);
        },
        () => {},
        () => {
          setQuestionsLoading(false);
        }
      );
      return;
    }
    if (questionInfo?.question?.id) {
      const game = getCurrentGame();
      INTOUCH_API.requestManager(
        "getInsightFormPairByQuestionId",
        {
          payload: {
            questionId: questionInfo.question.id,
            gameId: game.id,
          },
        },
        (response) => {
          setQuestionsWithAnswers(response.data, game.partner.id);
        },
        () => {},
        () => {
          setQuestionsLoading(false);
        }
      );
    }
  }, [questionInfo?.question?.id, questionInfo?.pairKey]);

  useEffect(() => {
    const game = getCurrentGame();
    const user = getUserData();
    if (questionInfo && !questionInfo.isViewed) {
      sendEvent(SOCKET_EVENTS.ON_VIEW, {
        questionId: questionInfo.questionId,
        // BLANK без questionId помечается просмотренной по pairKey
        pairKey: questionInfo.pairKey ?? null,
        room: game.id,
        recipientId: game.partner.id,
        senderId: user.id,
        isViewed: true,
      });
    }
  }, [questionInfo, questionInfo?.isViewed]);

  return {
    questions,
    questionInfo,
    questionName,
    questionsLoading,
  };
}
